import { useStaticQuery, graphql } from 'gatsby'

export const useCouponSectionQuery = () => {
  const { wpPage, wp } = useStaticQuery(graphql`
    query CouponSectionQuery {
      wpPage(title: { eq: "Home" }) {
        couponSection {
          couponSection {
            title
            link {
              title
              url
            }
            printButtonText
            coupons {
              text
              amount
              percentOrFixedAmount
              showOff
              finePrint
            }
          }
        }
      }
      wp {
        acfOptionsCommonItems {
          commonItems {
            logo {
              sourceUrl
              mediaDetails {
                width
                height
              }
            }
            logoAltText
          }
        }
      }
    }
  `)
  return { wpPage, wp }
}
